import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { X } from 'lucide-react';
import Logo from '../shared/Logo';

export default function Login({ onSwitchToSignup, onLoginSuccess, onCancel, isAdminLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signin } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signin(email, password);
      onLoginSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 relative">
        {!isAdminLogin && (
          <button
            onClick={onCancel}
            className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full"
          >
            <X size={20} />
          </button>
        )}

        <div className="flex items-center justify-center gap-3 mb-8">
          <Logo />
          <h1 className="text-2xl font-bold text-red-600">MyMapleShop</h1>
        </div>

        <h2 className="text-2xl font-bold text-center text-gray-900 mb-8">
          {isAdminLogin ? 'Admin Sign In' : 'Sign In'}
        </h2>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              placeholder="your@email.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 font-semibold disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        {!isAdminLogin && (
          <>
            <div className="mt-6 text-center">
              <p className="text-gray-600">
                Don't have an account?{' '}
                <button
                  onClick={onSwitchToSignup}
                  className="text-red-600 hover:text-red-700 font-semibold"
                >
                  Sign Up
                </button>
              </p>
            </div>

            <div className="mt-4 text-center">
              <button
                onClick={onCancel}
                className="text-gray-600 hover:text-gray-700 text-sm"
              >
                Continue as Guest
              </button>
            </div>
          </>
        )}

        {isAdminLogin && (
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 text-center mb-2">Admin Credentials:</p>
            <p className="text-xs text-gray-400 text-center">
              Email: admin@mymapleshop.com<br />
              Password: admin123
            </p>
            <div className="mt-4 text-center">
              <button
                onClick={onCancel}
                className="text-gray-600 hover:text-gray-700 text-sm"
              >
                Back to Store
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}